import { useState, useEffect } from 'react';
import Navigation from '../home/components/Navigation';
import Footer from './components/Footer';

export default function Blog() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (sectionId: string) => {
    if (window.location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = `/#${sectionId}`;
    }
  };

  const blogPosts = [
    {
      id: 1,
      title: 'AI導入で業務効率が3倍に！成功事例から学ぶポイント',
      excerpt: 'AIを導入することで、業務効率が劇的に向上した企業の事例をご紹介します。導入のポイントや注意点、具体的な成果について詳しく解説します。',
      date: '2026年1月20日',
      image: 'https://public.readdy.ai/ai/img_res/c23160f268829616bd2c488cf2cffd85.jpg',
      noteUrl: 'https://note.com/mako3978/n/n9b1d6c6ec8c7?sub_rt=share_pb'
    },
    {
      id: 2,
      title: 'ChatGPTを活用したライティング術：プロが教える5つのコツ',
      excerpt: 'ChatGPTを使って質の高いコンテンツを作成するための実践的なテクニックをご紹介。初心者でもすぐに使える具体的な方法を解説します。',
      date: '2026年1月10日',
      image: 'https://readdy.ai/api/search-image?query=Creative%20writing%20workspace%20with%20laptop%20showing%20AI%20writing%20assistant%20interface%2C%20modern%20desk%20setup%20with%20coffee%20and%20notebook%2C%20warm%20natural%20lighting%2C%20professional%20content%20creator%20environment&width=800&height=450&seq=blog2&orientation=landscape',
      noteUrl: 'https://note.com/mako3978/n/n5b6360cfefb6?app_launch=false'
    },
    {
      id: 3,
      title: 'SNS運用でフォロワーを10倍にする戦略とは',
      excerpt: 'SNS運用で実際にフォロワーを10倍に増やした事例をもとに、効果的な戦略と具体的な施策をご紹介します。',
      date: '2025年12月15日',
      image: 'https://readdy.ai/api/search-image?query=Social%20media%20analytics%20dashboard%20with%20growing%20follower%20graphs%20and%20engagement%20metrics%2C%20modern%20digital%20marketing%20workspace%2C%20vibrant%20colors%2C%20professional%20business%20setting&width=800&height=450&seq=blog3&orientation=landscape',
      noteUrl: 'https://note.com/mako3978/n/n0e4b2f48cd6f?sub_rt=share_pb'
    },
    {
      id: 4,
      title: 'AI時代のビジネス戦略：今すぐ始めるべき3つのこと',
      excerpt: 'AI技術の進化により、ビジネスの在り方が大きく変わりつつあります。今すぐ取り組むべき具体的なアクションをご紹介します。',
      date: '2025年11月28日',
      image: 'https://readdy.ai/api/search-image?query=Futuristic%20business%20meeting%20room%20with%20AI%20technology%20visualization%2C%20professional%20executives%20discussing%20strategy%2C%20modern%20corporate%20environment%20with%20digital%20displays%2C%20high-tech%20atmosphere&width=800&height=450&seq=blog4&orientation=landscape',
      noteUrl: 'https://note.com/mako3978/n/nf20a6f59f0a8?sub_rt=share_pb'
    },
    {
      id: 5,
      title: 'AIコンサルタント講座の受講生が語る、学びの成果とは',
      excerpt: 'AIコンサルタント講座を受講した方々の声をご紹介。実際にどのような成果が得られたのか、リアルな体験談をお届けします。',
      date: '2025年11月5日',
      image: 'https://readdy.ai/api/search-image?query=professional-japanese-business-seminar-training-classroom-scene-with-diverse-group-of-professionals-attending-AI-consultant-workshop-instructor-presenting-at-front-modern-conference-room-with-large-screens-showing-AI-technology-charts-graphs-engaged-participants-taking-notes-laptops-tablets-bright-natural-lighting-contemporary-office-environment-purple-pink-gradient-accents-professional-atmosphere-high-quality-photography&width=800&height=520&seq=blog-ai-consultant-training-success-stories-005&orientation=landscape',
      noteUrl: 'https://note.com/mako3978/n/n2cb872a25ead?sub_rt=share_pw'
    },
    {
      id: 6,
      title: 'コンテンツマーケティングの新常識：AIを活用した効率化',
      excerpt: 'AIを活用することで、コンテンツマーケティングの効率が大幅に向上します。最新のトレンドと実践方法を解説します。',
      date: '2025年10月20日',
      image: 'https://readdy.ai/api/search-image?query=Content%20marketing%20workspace%20with%20AI%20tools%20and%20analytics%2C%20modern%20digital%20marketing%20office%20with%20multiple%20screens%20showing%20content%20performance%2C%20professional%20creative%20environment&width=800&height=450&seq=blog6&orientation=landscape',
      noteUrl: 'https://note.com/mako3978/n/nef7f756805fe'
    }
  ];

  return (
    <div className="relative bg-white font-light">
      <Navigation scrolled={true} onNavigate={handleNavigation} />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-20 bg-gradient-to-br from-purple-50 to-pink-50">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-purple-900 mb-6">
            ブログ
          </h1>
          <p className="text-lg sm:text-xl text-purple-700 max-w-3xl mx-auto font-medium">
            AI活用のノウハウや実践的なビジネス戦略をお届けします
          </p>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-20 px-4 sm:px-6 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <article key={post.id} className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <a 
                  href={post.noteUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block cursor-pointer"
                >
                  <div className="relative w-full h-52 overflow-hidden bg-purple-100">
                    <img 
                      src={post.image} 
                      alt={post.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6">
                    <time className="text-sm font-medium text-purple-600 mb-3 block">
                      {post.date}
                    </time>
                    <h2 className="text-xl font-bold text-purple-900 mb-3 group-hover:text-purple-600 transition-colors line-clamp-2">
                      {post.title}
                    </h2>
                    <p className="text-base font-medium text-purple-700 line-clamp-3 mb-4">
                      {post.excerpt}
                    </p>
                    <div className="flex items-center text-purple-600 font-semibold text-sm group-hover:text-purple-700 transition-colors">
                      <span className="whitespace-nowrap">続きを読む</span>
                      <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                    </div>
                  </div>
                </a>
              </article>
            ))}
          </div>

          {/* View All Button */}
          <div className="text-center mt-16">
            <a
              href="https://note.com/mako3978"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-8 py-4 rounded-full font-semibold text-lg hover:from-purple-600 hover:to-pink-600 transition-all duration-300 hover:shadow-lg cursor-pointer whitespace-nowrap"
            >
              <span>noteで全ての記事を見る</span>
              <i className="ri-external-link-line text-xl"></i>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
